import React from 'react'
import SignUp from './Components/Javascript/Forms/Signup'
export default function SignUpPage() {
  return (
    <div>
      <SignUp/>
    </div>
  )
}
